"use client"

import HubPreviewButton from "@/components/ui/collection/hub-preview-button"
import { useHubPreview, type HubPreviewSound } from "@/hooks/useHubPreview"

/**
 * Category hubs are organic entry points, but until now only *collection*
 * hubs offered a one-tap preview. On a category hub the first play control
 * was a sound card, which sits below the fold at 390px. Same CTA, same
 * placement in the header, so both hub kinds answer "let me hear one" in the
 * first viewport (TES-1836 follow-up).
 *
 * No now-playing track list here: the category header already carries a
 * hero quote, feature chips and a stat grid, and the button's own `n / 3`
 * counter covers progress.
 */
export default function CategoryPreview({
  previewSounds,
  accentColor,
  categorySlug,
}: {
  previewSounds: HubPreviewSound[]
  accentColor: string
  categorySlug: string
}) {
  const { isPlaying, activeIndex, isLoading, toggle } = useHubPreview({
    previewSounds,
    coordinatorId: `category-hero-${categorySlug}`,
  })

  if (previewSounds.length === 0) return null

  return (
    <div className="mt-6">
      <HubPreviewButton
        previewSounds={previewSounds}
        accentColor={accentColor}
        isPlaying={isPlaying}
        activeIndex={activeIndex}
        isLoading={isLoading}
        onToggle={toggle}
      />
    </div>
  )
}
